// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__U-3WD","copyright":"Footer_copyright__+0tE0","credits":"Footer_credits__9u-ZY"};